<template>
  <v-list-tile>
    <v-list-tile-action/>
    <v-list-tile-content>
      <v-list-tile-title>{{ item.name }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action v-if="settings.includes('顯示開設系所') && item.records.length">
      <v-tooltip v-if="new Set(item.records.map(v => v.slice(5, 9))).size > 1" bottom>
        <v-chip :color="chipColor" slot="activator" outline disabled small>
          {{ `${record2dept(item.records[0])}` }}
          <v-icon small right class="ml-1">info</v-icon>
        </v-chip>
        <span v-html="depts"/>
      </v-tooltip>
      <v-chip v-else :color="chipColor" outline disabled small>
        {{ `${record2dept(item.records[0])}` }}
      </v-chip>
    </v-list-tile-action>
    <v-list-tile-action v-if="settings.includes('顯示開設學期') && item.records.length">
      <v-tooltip v-if="new Set(item.records.map(v => v.slice(0, 5))).size > 1" bottom>
        <v-chip :color="chipColor" slot="activator" outline disabled small>
          {{ `${record2time(item.records[0])}` }}
          <v-icon small right class="ml-1">info</v-icon>
        </v-chip>
        <span v-html="ordinalYear"/>
      </v-tooltip>
      <v-chip v-else :color="chipColor" outline disabled small>
        {{ `${record2time(item.records[0])}` }}
      </v-chip>
    </v-list-tile-action>
    <v-list-tile-action v-if="settings.includes('顯示學分') && item.credits.length">
      <v-tooltip v-if="new Set(item.credits).size > 1" bottom>
        <v-chip :color="chipColor" text-color="white" slot="activator" disabled small>
          {{ `${item.credits[0]} 學分` }}
          <v-icon small right class="ml-1">info</v-icon>
        </v-chip>
        <span v-html="creditSemesters"/>
      </v-tooltip>
      <v-chip v-else :color="chipColor" text-color="white" disabled small>
        {{ `${item.credits[0]} 學分` }}
      </v-chip>
    </v-list-tile-action>
    <v-list-tile-action v-if="item.credits.length === 0">
      <v-chip color="error" outline disabled small>四年未開</v-chip>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
const codeMapping = {
  'ANTH': '人類所',
  'ANTU': '人類所與交大合作課程',
  'ASTR': '天文所',
  'BME': '醫工所',
  'BMES': '醫環系',
  'CF': '大學中文',
  'CHE': '化工系',
  'CHEM': '化學系',
  'CL': '中文系',
  'CLC': '華語中心',
  'CLU': '中文系與交大合作課程',
  'COM': '通訊所',
  'CS': '資工系',
  'DL': '遠距課程',
  'DMS': '醫科系',
  'E': '工學院',
  'ECON': '經濟系',
  'EE': '電機系',
  'EECS': '電資院學士班',
  'EMBA': '高階經營管理碩士班',
  'EMS': '高階經管境外專班',
  'ENE': '電子所',
  'ESS': '工科系',
  'FL': '外語系',
  'FLU': '外語系與交大合作課程',
  'GE': '通識教育中心',
  'GEC': '通識核心',
  'GEU': '通識中心與交大合作課',
  'GLLB': '學士後法律學士班',
  'GOM': '全球營運管理碩士學程',
  'GPTS': '台灣研究教師在職進修',
  'HIS': '歷史所',
  'HSS': '人社院學士班',
  'HSSU': '人社學士班與交大合作',
  'IACS': '亞際文化碩士學程',
  'IACU': '亞際文化與台聯大合作',
  'ICMS': '計科所',
  'IEEM': '工工系',
  'IEM': '工工系碩士在職專班',
  'IMBA': 'IMBA',
  'IMS': '跨院國際碩士',
  'IPE': '工學院學士班',
  'IPHD': '跨院國際博士班學位學程',
  'IPNS': '原科院學士班',
  'IPT': '光電所',
  'IPTH': '清華學院學士班',
  'ISA': '資應所',
  'ISS': '服務科學所',
  'JAD': '藝設系',
  'JADN': '藝設專班',
  'JMU': '音樂系',
  'JMUN': '音樂專班',
  'KCSN': '學前特教專班',
  'KEC': '環文系',
  'KECN': '環文專班',
  'KEE': '幼教系',
  'KEEN': '幼教專班',
  'KEL': '教科系',
  'KELN': '教科專班',
  'KENI': '英教系',
  'KLST': '學科所',
  'KMS': '數理所',
  'KMSN': '數理專班',
  'KPC': '心諮系',
  'KPCN': '心諮專班',
  'KPE': '體育系',
  'KPEN': '體育專班',
  'KSPE': '特教系',
  'KTLT': '臺語所',
  'LANG': '語言中心',
  'LING': '語言所',
  'LS': '生科系',
  'LSBS': '生資所',
  'LSBT': '生技所',
  'LSC': '生科院',
  'LSIN': '神經科學博士學位學程',
  'LSIP': '生科院學士班',
  'LSMC': '分生所',
  'LSMM': '分醫所',
  'LSSN': '系神所',
  'LST': '科法所',
  'MATH': '數學系',
  'MATU': '數學系與交大合作課程',
  'MBA': '經營管理碩士班',
  'MFB': '財務金融碩士在職專班',
  'MI': '軍訓',
  'MPM': '公共政策與管理專班',
  'MS': '材料系',
  'NEMS': '奈微所',
  'NES': '核工所',
  'PE': '體育',
  'PE1': '大一體育',
  'PE3': '體育(校隊)',
  'PHIL': '哲學所',
  'PHYS': '物理系',
  'PHYU': '物理系與交大合作課程',
  'PME': '動機系',
  'QF': '計財系',
  'RDDM': '半導體元件及製程專班',
  'RDIC': '積體電路設計專班',
  'RDPE': '產業研發碩士電力電子',
  'SCI': '理學院學士班',
  'SLS': '先進光源科技學位學程',
  'SNHC': '社群人智國際學程',
  'SOC': '社會所',
  'STAT': '統計所',
  'STAU': '統計所與交大合作課程',
  'TE': '師培中心(中等教程)',
  'TEG': '師培中心(一般課程)',
  'TIGP': '國際研究生學程',
  'TL': '台文所',
  'TM': '科管所',
  'UPMT': '科管院學士班',
  'ZY': '服務學習',

  'KIPE': '竹師教育學院學士班',
  'TEE': '師培中心(國小教程)',
  'ILS': '學科所',
};

const timeMapping = {
  '10': '上',
  '20': '下',
  '30': '暑',
};

export default {
  name: 'program-list-item',
  props: {
    item: Object,
    settings: Array,
  },
  data() {
    return {
      chipColor: this.item.isEnrolled ? 'teal' : 'primary',
    };
  },
  computed: {
    creditSemesters() {
      const { credits, records } = this.item;
      const output = Array.from(new Set(credits)).reduce((acc, v) => {
        acc[v] = new Set();
        return acc;
      }, {});
      credits.forEach((v, i) => output[v].add(this.record2time(records[i])));
      return Object.keys(output).map(v => `${v} 學分：${Array.from(output[v]).join('、')}`).join('<br>');
    },
    ordinalYear(){
      const { records } = this.item;
      const output = Array.from(new Set(records.map(v => v.slice(3, 5)))).reduce((acc, v) => {
        acc[v] = new Set();
        return acc;
      }, {});
      records.forEach(v => output[v.slice(3, 5)].add(v.slice(0, 3)));
      return Object.keys(output).map(v => `${timeMapping[v]}：${Array.from(output[v]).join('、')}`).join('<br>');
    },
    depts() {
      const { records } = this.item;
      return Array.from(new Set(records.map(v => v.slice(5, 9).trim()))).map(v => codeMapping[v]).join('<br>');
    }
  },
  methods: {
    record2time(r) {
      return `${r.slice(0, 3)} ${timeMapping[r.slice(3, 5)]}`;
    },
    record2dept(r) {
      const code = r.slice(5, 9).trim();
      if (!codeMapping[code]) console.log(code);
      return codeMapping[code] || code;
    },
  },
}
</script>